import { DataBean } from "../DataBean";

export class ScheduleEmployeeBonus extends DataBean {

    public async getScheduleEmployeeBonusCatalog(accountID: any, idEmploymentBonus: any, date: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getScheduleEmployeeBonusCatalog_Number_Number_java.util.Date", [accountID, idEmploymentBonus, date]);
    }

    public async deleteScheduleEmployeeBonus(idScheduleEmployeeBonus: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteScheduleEmployeeBonus_Number_Number", [idScheduleEmployeeBonus, idEmployee]);
    }

    public async getScheduleEmployeeBonusItemCatalog(idScheduleEmployeeBonus: number, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getScheduleEmployeeBonusItemCatalog_Number_Number_Number", [idScheduleEmployeeBonus, page, recordsPerPage]);
    }

    public async updateScheduleEmployeeBonus(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.ScheduleEmployeeBonus_updateScheduleEmployeeBonus_com.quickdataerp.bean.employees.ScheduleEmployeeBonus", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.employees.ScheduleEmployeeBonus"
            }
        ]);
    }

}